import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches a presigned URL for previewing a file inline (e.g. rendering an image
 * or PDF in the viewer). Pass `null` to disable the query. The result is cached
 * by file id so re-visiting a file while paging through the viewer is instant.
 */
export function useGetFileDownloadUrl(fileId: string | null) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['file-download-url', fileId],
    enabled: fileId != null,
    // Presigned URLs are valid for an hour; avoid refetching on every focus.
    staleTime: 30 * 60 * 1000,
    queryFn: async () => {
      const response = await api.get('/files/:fileId/download-url', { params: { fileId: fileId! } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.downloadUrl
    },
  })
}
